import { Layout } from '@components/common'
import { Container } from '@components/ui'
import DiamondFilterProvider from 'context/diamondFilterContext'
import DiamondsFilter from '@components/yadav/common/DiamondsFilter'
import DiamondsTable from '@components/yadav/common/DiamondsTable'
import TabDiamondsType from '@components/yadav/ui/TabDiamondsType'
import { StepIndicator, TotalDiamondCount } from '@components/yadav/ui'
import { useEffect, useState } from 'react'
import { GetStaticPathsContext, GetStaticPropsContext } from 'next'
import { validateFilterURLParams } from '@utils/validate-filter-url-params'
import Head from 'next/head'
import Link from 'next/link'
import { useRouter } from 'next/router'

export async function getStaticProps({
  params,
}: GetStaticPropsContext<{ slug: string[] | undefined }>) {
  if (params == undefined || params.slug == undefined) {
    return {
      props: {
        params: null,
      },
    }
  }

  const isValid = validateFilterURLParams(params.slug)

  if (!isValid) {
    console.log('Not valid diamond slug.')
    return {
      notFound: true,
    }
  }

  return {
    props: {
      params: params.slug,
    },
  }
}

export async function getStaticPaths({}: GetStaticPathsContext) {
  return {
    paths: [],
    fallback: 'blocking',
  }
}

export default function NaturalLooseDiamonds({
  params,
}: {
  params: string[] | null
}) {
  const router = useRouter()
  const [startSetting, setStartSetting] = useState('')

  useEffect(() => {
    const { ring } = router.query

    if (ring && typeof ring === 'string') {
      setStartSetting('setting')
      return
    }

    try {
      let settingLocalStorage = localStorage.getItem('setting')
      let diamondLocalStorage = localStorage.getItem('diamond')
      if (settingLocalStorage) {
        setStartSetting('setting')
      } else if (diamondLocalStorage) {
        setStartSetting('diamond')
      } else {
        setStartSetting('diamond')
      }
    } catch (error) {
      console.log(error)
    }
  }, [router.query])

  const addBreadcrumbsJsonLd = () => {
    const breadcrumbsData = {
      '@context': 'https://schema.org/',
      '@type': 'BreadcrumbList',
      itemListElement: [
        {
          '@type': 'ListItem',
          position: 1,
          name: 'Home',
          item: `${process.env.baseUrl}`,
        },
        {
          '@type': 'ListItem',
          position: 2,
          name: 'Diamonds',
          item: `${process.env.baseUrl}/natural-loose-diamonds`,
        },
      ],
    }

    return {
      __html: JSON.stringify(breadcrumbsData),
    }
  }

  return (
    <>
      <Head>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={addBreadcrumbsJsonLd()}
          key="natural-loose-diamonds-breadcrumbs-jsonld"
        />
      </Head>
      <StepIndicator
        className="sm:my-4 sm:mx-auto sm:max-w-7xl w-full"
        startWith={startSetting}
      />
      <nav
        className="yd-breadcrumbs-container sm:my-4 sm:mx-auto sm:max-w-7xl w-full px-3"
        aria-label="breadcrumbs"
      >
        <ol className="yd-breadcrumbs-list">
          <Link href="/">
            <a>
              <li className="yd-breadcrumbs-inactive-item capitalize">Home</li>
            </a>
          </Link>
          <Link href="/t/fine-jewelry">
            <a>
              <li className="yd-breadcrumbs-inactive-item capitalize">
                Jewelry
              </li>
            </a>
          </Link>
          <Link href="/natural-loose-diamonds">
            <a>
              <li className="yd-breadcrumbs-active-item capitalize">
                Diamonds
              </li>
            </a>
          </Link>
        </ol>
      </nav>
      <Container clean className="mx-auto max-w-7xl w-full mlg:px-3">
        <TabDiamondsType type="natural" />
        <DiamondFilterProvider diamondType="natural">
          <TotalDiamondCount className="mb-5 md:hidden" />
          <DiamondsFilter className="mb-6" />
          <TotalDiamondCount className="hidden md:block md:mb-10 md:mt-1" />
          <DiamondsTable />
        </DiamondFilterProvider>
      </Container>
    </>
  )
}

NaturalLooseDiamonds.Layout = Layout
